<template>
  <li class="reservation-list-item col-12 d-flex justify-content-start" v-if="item && item.id" v-show="index === 0 || show">
    <div class="input-table-shadow" @click="selectItem">
      <div class="d-flex row align-items-center">
        <div class="col-1 reservation-id-col">
          <input
            class="pl-3 reservation-id"
            type="text"
            :value="item.reservationId"
            readonly="readonly"
          />
          <router-link :to="'/reservation/' + this.item.reservationId" target="_blank">
            <img src="@/assets/svg/external-link.svg" alt="" />
          </router-link>
        </div>
        <div class="col-1">
          {{ parseInt(item.automaticallyBooked) ? 'Booked automatically' : 'Booked manually' }}
        </div>
        <div class="col-1 text-center">
          {{ item.service.code }}
        </div>
        <div class="col-2">
          {{ item.service.title_EN }}
        </div>
        <div class="col-1 text-center">
          {{ item.persons_initials }}
        </div>
        <div class="col-1">
          {{ item.reference }}
        </div>
        <div class="col-1 text-center">
          {{item.amount}}
        </div>
        <div class="col-1">
          €{{ item.sumTotalSalePrice / 100 }}
        </div>
        <div class="col-1">
          <input
            type="text"
            :value="$moment(item.dateFrom, 'YYYY-MM-DD').format('DD.MM.YYYY')"
            readonly="readonly"
          />
        </div>
        <div class="col-1">
          <input
            type="text"
            :value="$moment(item.dateUntil, 'YYYY-MM-DD').format('DD.MM.YYYY')"
            readonly="readonly"
          />
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    show: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {}
  },
  computed: {
    personName () {
      return this.item.person.firstName + ' ' + this.item.person.lastName
    },
    actionColor () {
      return `status-${this.item.reservationStatus.code.toLowerCase()}`
    }
  },
  methods: {
    getTime (date) {
      if (!date) {
        return ''
      }
      return this.$moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH[h]mm')
    },
    getUserInitials (user) {
      if (!user) {
        return ''
      }
      if (user.firstName && user.lastName) {
        let initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
        return initials.toUpperCase()
      }
      return ''
    },
    selectItem (e) {
      // if we click on link with target="_blank" we don't need to go inside twice
      if (e.target && e.target.getAttribute('target') !== '_blank' && e.target.parentElement.getAttribute('target') !== '_blank') {
        this.$router.push('/reservation/' + this.item.reservationId)
      }
    }
  }
}
</script>

<style>
  .reservation-list-item .col, .reservation-list-item .col-1, .reservation-list-item .col-2 {
    padding: 0 4px
  }
  .reservation-id-col{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
  }
  .reservation-id-col input[type="text"]{
    min-width: 50px;
  }
  .reservation-id {
    margin-right: 10px
  }
  .col.col-30px{
    max-width: 30px;
  }
  .col-60px{
    max-width: 60px;
  }
  .col-90px{
    max-width: 90px;
  }
  .col.col-30px input[type="text"] {
    width: 20px;
    max-width: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservation/LineListItem.vue